interface ISubtitleProps {
  children: string | React.ReactNode;
}

export const Subtitle = ({ children }: ISubtitleProps) => <p className="text-thin">{children}</p>;
